import type { Decimal } from 'decimal.js';

export class ProcessSelfServeAmendDto {
    readonly paymentOptionId: string;

    readonly tempWeeklyPrice: Decimal;

    constructor(paymentOptionId: string, tempWeeklyPrice: Decimal) {
        this.paymentOptionId = paymentOptionId;
        this.tempWeeklyPrice = tempWeeklyPrice;
    }
}
